export const normalizeToCamelCase = (item: string | undefined | null) => {
  if (!item || typeof item !== 'string') {
    return ''
  }
  return item.charAt(0).toUpperCase() + item.slice(1)
}

export const normalizeToKebabCase = (item: string | undefined | null) => {
  if (!item || typeof item !== 'string') {
    return ''
  }
  return item.toLowerCase().replace(/ /g, '-')
}

export const normalizeWithoutSpecialCharacters = (
  item: string | undefined | null,
) => {
  if (!item || typeof item !== 'string') {
    return ''
  }
  return item.normalize('NFKD').replace(/[^\w]/g, '')
}
